import { render, staticRenderFns } from "./TaskPanelFrame.vue?vue&type=template&id=9358d76c&"
import script from "./TaskPanelFrame.vue?vue&type=script&lang=js&"
export * from "./TaskPanelFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports